var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 78,
    viewBox: "0 0 79 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M39.5 4C58.8165 4 74.5 19.6835 74.5 39C74.5 58.3165 58.8165 74 39.5 74C20.1835 74 4.5 58.3165 4.5 39C4.5 19.6835 20.1835 4 39.5 4Z",
    fill: "#EA1423"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 16.5C51.9178 16.5 62 26.5822 62 39C62 51.4177 51.9178 61.5 39.5 61.5C27.0823 61.5 17 51.4177 17 39C17 26.5822 27.0823 16.5 39.5 16.5Z",
    fill: "#EA1423"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9958 30H31V48H40",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 43.5L49 39L44.5 34.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36 38.9961H49",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.e3e86c1b993f068fc907be95c470c8c5.svg";
export { ForwardRef as ReactComponent };